/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SigninRouteImport } from './routes/signin'
import { Route as AdminRouteImport } from './routes/_admin'
import { Route as AdminIndexRouteImport } from './routes/_admin.index'
import { Route as AdminUsersRouteImport } from './routes/_admin.users'
import { Route as AdminTranslationRouteImport } from './routes/_admin.translation'
import { Route as AdminReviewsRouteImport } from './routes/_admin.reviews'
import { Route as AdminOrdersRouteImport } from './routes/_admin.orders'
import { Route as AdminDisputesRouteImport } from './routes/_admin.disputes'
import { Route as AdminCategoriesRouteImport } from './routes/_admin.categories'
import { Route as AdminBannersRouteImport } from './routes/_admin.banners'
import { Route as AdminAuditRouteImport } from './routes/_admin.audit'
import { Route as AdminProductsIndexRouteImport } from './routes/_admin.products.index'
import { Route as AdminUsersIdRouteImport } from './routes/_admin.users.$id'
import { Route as AdminProductsNewRouteImport } from './routes/_admin.products.new'
import { Route as AdminProductsIdRouteImport } from './routes/_admin.products.$id'
import { Route as AdminOrdersIdRouteImport } from './routes/_admin.orders.$id'
import { Route as AdminDisputesIdRouteImport } from './routes/_admin.disputes.$id'

const SigninRoute = SigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/_admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRoute,
} as any)
const AdminTranslationRoute = AdminTranslationRouteImport.update({
  id: '/translation',
  path: '/translation',
  getParentRoute: () => AdminRoute,
} as any)
const AdminReviewsRoute = AdminReviewsRouteImport.update({
  id: '/reviews',
  path: '/reviews',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOrdersRoute = AdminOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDisputesRoute = AdminDisputesRouteImport.update({
  id: '/disputes',
  path: '/disputes',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCategoriesRoute = AdminCategoriesRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => AdminRoute,
} as any)
const AdminBannersRoute = AdminBannersRouteImport.update({
  id: '/banners',
  path: '/banners',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAuditRoute = AdminAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AdminRoute,
} as any)
const AdminProductsIndexRoute = AdminProductsIndexRouteImport.update({
  id: '/products/',
  path: '/products/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminUsersIdRoute = AdminUsersIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminUsersRoute,
} as any)
const AdminProductsNewRoute = AdminProductsNewRouteImport.update({
  id: '/products/new',
  path: '/products/new',
  getParentRoute: () => AdminRoute,
} as any)
const AdminProductsIdRoute = AdminProductsIdRouteImport.update({
  id: '/products/$id',
  path: '/products/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOrdersIdRoute = AdminOrdersIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminOrdersRoute,
} as any)
const AdminDisputesIdRoute = AdminDisputesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminDisputesRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AdminIndexRoute
  '/signin': typeof SigninRoute
  '/audit': typeof AdminAuditRoute
  '/banners': typeof AdminBannersRoute
  '/categories': typeof AdminCategoriesRoute
  '/disputes': typeof AdminDisputesRouteWithChildren
  '/orders': typeof AdminOrdersRouteWithChildren
  '/reviews': typeof AdminReviewsRoute
  '/translation': typeof AdminTranslationRoute
  '/users': typeof AdminUsersRouteWithChildren
  '/disputes/$id': typeof AdminDisputesIdRoute
  '/orders/$id': typeof AdminOrdersIdRoute
  '/products/$id': typeof AdminProductsIdRoute
  '/products/new': typeof AdminProductsNewRoute
  '/users/$id': typeof AdminUsersIdRoute
  '/products/': typeof AdminProductsIndexRoute
}
export interface FileRoutesByTo {
  '/signin': typeof SigninRoute
  '/audit': typeof AdminAuditRoute
  '/banners': typeof AdminBannersRoute
  '/categories': typeof AdminCategoriesRoute
  '/disputes': typeof AdminDisputesRouteWithChildren
  '/orders': typeof AdminOrdersRouteWithChildren
  '/reviews': typeof AdminReviewsRoute
  '/translation': typeof AdminTranslationRoute
  '/users': typeof AdminUsersRouteWithChildren
  '/': typeof AdminIndexRoute
  '/disputes/$id': typeof AdminDisputesIdRoute
  '/orders/$id': typeof AdminOrdersIdRoute
  '/products/$id': typeof AdminProductsIdRoute
  '/products/new': typeof AdminProductsNewRoute
  '/users/$id': typeof AdminUsersIdRoute
  '/products': typeof AdminProductsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_admin': typeof AdminRouteWithChildren
  '/signin': typeof SigninRoute
  '/_admin/audit': typeof AdminAuditRoute
  '/_admin/banners': typeof AdminBannersRoute
  '/_admin/categories': typeof AdminCategoriesRoute
  '/_admin/disputes': typeof AdminDisputesRouteWithChildren
  '/_admin/orders': typeof AdminOrdersRouteWithChildren
  '/_admin/reviews': typeof AdminReviewsRoute
  '/_admin/translation': typeof AdminTranslationRoute
  '/_admin/users': typeof AdminUsersRouteWithChildren
  '/_admin/': typeof AdminIndexRoute
  '/_admin/disputes/$id': typeof AdminDisputesIdRoute
  '/_admin/orders/$id': typeof AdminOrdersIdRoute
  '/_admin/products/$id': typeof AdminProductsIdRoute
  '/_admin/products/new': typeof AdminProductsNewRoute
  '/_admin/users/$id': typeof AdminUsersIdRoute
  '/_admin/products/': typeof AdminProductsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/signin'
    | '/audit'
    | '/banners'
    | '/categories'
    | '/disputes'
    | '/orders'
    | '/reviews'
    | '/translation'
    | '/users'
    | '/disputes/$id'
    | '/orders/$id'
    | '/products/$id'
    | '/products/new'
    | '/users/$id'
    | '/products/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/signin'
    | '/audit'
    | '/banners'
    | '/categories'
    | '/disputes'
    | '/orders'
    | '/reviews'
    | '/translation'
    | '/users'
    | '/'
    | '/disputes/$id'
    | '/orders/$id'
    | '/products/$id'
    | '/products/new'
    | '/users/$id'
    | '/products'
  id:
    | '__root__'
    | '/_admin'
    | '/signin'
    | '/_admin/audit'
    | '/_admin/banners'
    | '/_admin/categories'
    | '/_admin/disputes'
    | '/_admin/orders'
    | '/_admin/reviews'
    | '/_admin/translation'
    | '/_admin/users'
    | '/_admin/'
    | '/_admin/disputes/$id'
    | '/_admin/orders/$id'
    | '/_admin/products/$id'
    | '/_admin/products/new'
    | '/_admin/users/$id'
    | '/_admin/products/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AdminRoute: typeof AdminRouteWithChildren
  SigninRoute: typeof SigninRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signin': {
      id: '/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof SigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_admin': {
      id: '/_admin'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_admin/': {
      id: '/_admin/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/users': {
      id: '/_admin/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/translation': {
      id: '/_admin/translation'
      path: '/translation'
      fullPath: '/translation'
      preLoaderRoute: typeof AdminTranslationRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/reviews': {
      id: '/_admin/reviews'
      path: '/reviews'
      fullPath: '/reviews'
      preLoaderRoute: typeof AdminReviewsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/orders': {
      id: '/_admin/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof AdminOrdersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/disputes': {
      id: '/_admin/disputes'
      path: '/disputes'
      fullPath: '/disputes'
      preLoaderRoute: typeof AdminDisputesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/categories': {
      id: '/_admin/categories'
      path: '/categories'
      fullPath: '/categories'
      preLoaderRoute: typeof AdminCategoriesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/banners': {
      id: '/_admin/banners'
      path: '/banners'
      fullPath: '/banners'
      preLoaderRoute: typeof AdminBannersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/audit': {
      id: '/_admin/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AdminAuditRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/products/': {
      id: '/_admin/products/'
      path: '/products'
      fullPath: '/products/'
      preLoaderRoute: typeof AdminProductsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/users/$id': {
      id: '/_admin/users/$id'
      path: '/$id'
      fullPath: '/users/$id'
      preLoaderRoute: typeof AdminUsersIdRouteImport
      parentRoute: typeof AdminUsersRoute
    }
    '/_admin/products/new': {
      id: '/_admin/products/new'
      path: '/products/new'
      fullPath: '/products/new'
      preLoaderRoute: typeof AdminProductsNewRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/products/$id': {
      id: '/_admin/products/$id'
      path: '/products/$id'
      fullPath: '/products/$id'
      preLoaderRoute: typeof AdminProductsIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/orders/$id': {
      id: '/_admin/orders/$id'
      path: '/$id'
      fullPath: '/orders/$id'
      preLoaderRoute: typeof AdminOrdersIdRouteImport
      parentRoute: typeof AdminOrdersRoute
    }
    '/_admin/disputes/$id': {
      id: '/_admin/disputes/$id'
      path: '/$id'
      fullPath: '/disputes/$id'
      preLoaderRoute: typeof AdminDisputesIdRouteImport
      parentRoute: typeof AdminDisputesRoute
    }
  }
}

interface AdminDisputesRouteChildren {
  AdminDisputesIdRoute: typeof AdminDisputesIdRoute
}

const AdminDisputesRouteChildren: AdminDisputesRouteChildren = {
  AdminDisputesIdRoute: AdminDisputesIdRoute,
}

const AdminDisputesRouteWithChildren = AdminDisputesRoute._addFileChildren(
  AdminDisputesRouteChildren,
)

interface AdminOrdersRouteChildren {
  AdminOrdersIdRoute: typeof AdminOrdersIdRoute
}

const AdminOrdersRouteChildren: AdminOrdersRouteChildren = {
  AdminOrdersIdRoute: AdminOrdersIdRoute,
}

const AdminOrdersRouteWithChildren = AdminOrdersRoute._addFileChildren(
  AdminOrdersRouteChildren,
)

interface AdminUsersRouteChildren {
  AdminUsersIdRoute: typeof AdminUsersIdRoute
}

const AdminUsersRouteChildren: AdminUsersRouteChildren = {
  AdminUsersIdRoute: AdminUsersIdRoute,
}

const AdminUsersRouteWithChildren = AdminUsersRoute._addFileChildren(
  AdminUsersRouteChildren,
)

interface AdminRouteChildren {
  AdminAuditRoute: typeof AdminAuditRoute
  AdminBannersRoute: typeof AdminBannersRoute
  AdminCategoriesRoute: typeof AdminCategoriesRoute
  AdminDisputesRoute: typeof AdminDisputesRouteWithChildren
  AdminOrdersRoute: typeof AdminOrdersRouteWithChildren
  AdminReviewsRoute: typeof AdminReviewsRoute
  AdminTranslationRoute: typeof AdminTranslationRoute
  AdminUsersRoute: typeof AdminUsersRouteWithChildren
  AdminIndexRoute: typeof AdminIndexRoute
  AdminProductsIdRoute: typeof AdminProductsIdRoute
  AdminProductsNewRoute: typeof AdminProductsNewRoute
  AdminProductsIndexRoute: typeof AdminProductsIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAuditRoute: AdminAuditRoute,
  AdminBannersRoute: AdminBannersRoute,
  AdminCategoriesRoute: AdminCategoriesRoute,
  AdminDisputesRoute: AdminDisputesRouteWithChildren,
  AdminOrdersRoute: AdminOrdersRouteWithChildren,
  AdminReviewsRoute: AdminReviewsRoute,
  AdminTranslationRoute: AdminTranslationRoute,
  AdminUsersRoute: AdminUsersRouteWithChildren,
  AdminIndexRoute: AdminIndexRoute,
  AdminProductsIdRoute: AdminProductsIdRoute,
  AdminProductsNewRoute: AdminProductsNewRoute,
  AdminProductsIndexRoute: AdminProductsIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AdminRoute: AdminRouteWithChildren,
  SigninRoute: SigninRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
